import { COLORS } from "../../utils/js/constants";

export default function formFieldChipStyle(theme) {
  return {
    addButton: {
      backgroundColor: COLORS.green,
      color: "white",
      display: "block"
    },
    chip: {
      backgroundColor: COLORS.lightYellow,
      fontWeight: "bold",
      marginLeft: 5,
      marginBottom: 5
    },
    form: {
      padding: '2px 4px',
      marginBottom: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      boxShadow: "none"
    },
    input: {
      flex: 1,
      marginRight: '5px',
      "& .MuiFormLabel-root, .MuiInputBase-input": {
        color: "white",
      }
    }
  }
}
